"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paySDK = void 0;

var _httpRequest = _interopRequireDefault(require("../httpRequest"));

var _common = require("../common");

var _IGC_JS2Native = require("../IGC_JS2Native");

require("url-search-params-polyfill");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @file 支付相关
 * @author qiaogang
 * @date 2019-11-28
 */
var PRE_ORDER_ID = 'igc_pre_order_id';
var ORDER_STATUS = 'igc_order_status';
var paySDK = {
  _type: 'h5',
  _channel: 'wxpay',

  /**
   * 初始化配置
   * @param {Object} options
   * @param {string=} options.type 支付类型，默认 h5。支持 'h5'支付 / 'wechat' 微信内支付 / 'app' APP内支付
   * @param {string=} options.channel 支付渠道，默认 wxpay。暂无其他类型。
   */
  config: function config() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = options.type,
        channel = options.channel;

    if (type) {
      this._type = type.toLowerCase();
    }

    if (channel) {
      this._channel = channel.toLowerCase();
    }

    return this;
  },

  /**
   * 调用支付
   * @param {Object} options
   * @options {Object} options.params 支付参数，不同的场景参数不同
   * @options {string=} options.redirectUrl h5 购买成功后跳转的页面
   * @options {Function=} options.beforeInvokeApp h5 支付唤起前的钩子函数。返回 true 时阻断 h5 跳转，默认不阻止
   * @options {Function=} options.afterResponse 提供对返回结果处理的钩子函数，支持对函数进行二次处理下单返回的数据
   * @options {string=} options.version 指定商城下单版本号。默认 v2
   * @example:
   *
   * paySDK.invoke({
   *   params: {
   *     phone: '',
   *     courseTimeId: '',
   *   },
   *   redirectUrl: '',
   *   beforeInvokeApp: ({ responseBody }) => {
   *     // 如果需要阻止 h5 唤起 app 跳转，函数返回 true
   *     // return true;
   *   }
   * })
   */
  invoke: function invoke() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$url = options.url,
        url = _options$url === void 0 ? '/mall-server/api/shop/order/submitShopOrder' : _options$url,
        params = options.params,
        _options$requestOptio = options.requestOptions,
        requestOptions = _options$requestOptio === void 0 ? {} : _options$requestOptio,
        _options$redirectUrl = options.redirectUrl,
        redirectUrl = _options$redirectUrl === void 0 ? location.href : _options$redirectUrl,
        afterResponse = options.afterResponse,
        _options$beforeInvoke = options.beforeInvokeApp,
        beforeInvokeApp = _options$beforeInvoke === void 0 ? function () {} : _options$beforeInvoke,
        _options$version = options.version,
        version = _options$version === void 0 ? 'v2' : _options$version; // 商城 v1 走另一个接口

    if (version === 'v1') {
      url = '/mall-server/api/order/submitOrder';
    }

    var opts = (0, _common.defaults)(requestOptions, {
      forceAjax: true
    }); // 微信支付

    if (this._channel === 'wxpay') {
      return _httpRequest["default"].post(url, params, opts).then(function (res) {
        // 提供对返回结果处理的钩子函数，支持对函数进行二次处理
        if (typeof afterResponse === 'function') {
          var res2 = afterResponse.call(_this, res);

          if (typeof res2 !== 'undefined') {
            res = res2;
          }
        }

        if (res.code === 10000) {
          if (_this._type === 'h5') {
            // 兼容 v1 v2 商城返回的数据
            var h5BrowserPay = res.data.h5BrowserPay;

            var _ref = h5BrowserPay || res.data,
                mwebUrl = _ref.mwebUrl,
                orderId = _ref.orderId;

            var orderIdStr = "".concat(PRE_ORDER_ID, "=").concat(orderId);
            var orderStatusStr = "".concat(ORDER_STATUS, "=0"); // 替换 pre_order_id 和 order_status，防止在已有该字段情况下，重复追加

            var reg1 = new RegExp(PRE_ORDER_ID + '=[^&]*&?', 'ig');
            var reg2 = new RegExp(ORDER_STATUS + '=[^&]*&?', 'ig');
            redirectUrl = redirectUrl.replace(reg1, '').replace(reg2, '');
            var concatSign = redirectUrl.indexOf('?') === -1 ? '?' : '&';
            redirectUrl += "".concat(concatSign).concat(orderIdStr, "&").concat(orderStatusStr);
            mwebUrl += "&redirect_url=".concat(encodeURIComponent(redirectUrl));
            var skip = beforeInvokeApp.call(_this, {
              responseBody: res
            });

            if (!skip) {
              // 跳转至微信 mweb_url，用于唤起微信支付
              location.href = mwebUrl;
              return Promise.resolve({
                code: 0,
                msg: "\u652F\u4ED8\u5B8C\u6210",
                res: res
              });
            } else {
              return Promise.reject({
                code: 4,
                msg: "\u8DF3\u8FC7\u652F\u4ED8",
                res: res
              });
            }
          } else if (_this._type === 'wechat') {
            var wechatBrowserPay = res.data.wechatBrowserPay;

            var _skip = beforeInvokeApp.call(_this, {
              responseBody: res
            });

            if (!_skip) {
              return _this._wxJSAPIPay(wechatBrowserPay, res);
            } else {
              return Promise.reject({
                code: 4,
                msg: "\u8DF3\u8FC7\u652F\u4ED8",
                res: res
              });
            }
          } else if (_this._type === 'app') {
            var appWechatPay = res.data.appWechatPay;
            var timestamp = appWechatPay.timeStamp,
                packages = appWechatPay["package"],
                orderid = appWechatPay.orderId,
                sign = appWechatPay.paySign,
                appid = appWechatPay.appId,
                signtype = appWechatPay.signType,
                partnerid = appWechatPay.partnerId,
                prepayid = appWechatPay.prepayId,
                noncestr = appWechatPay.nonceStr;

            var _skip2 = beforeInvokeApp.call(_this, {
              responseBody: res
            });

            if (!_skip2) {
              return (0, _IGC_JS2Native.JS2Native)({
                name: 'wXPay',
                params: {
                  channel: 'wechat',
                  pay_params: {
                    timestamp: timestamp,
                    'package': packages,
                    orderid: orderid,
                    signtype: signtype,
                    sign: sign,
                    appid: appid,
                    partnerid: partnerid,
                    prepayid: prepayid,
                    noncestr: noncestr
                  }
                }
              }).then(function (_res) {
                if (_res.code === 0) {
                  return Promise.resolve({
                    code: 0,
                    msg: '支付完成',
                    appRes: _res,
                    res: res
                  });
                } else {
                  return Promise.reject({
                    code: 1,
                    msg: 'App 支付失败',
                    appRes: _res,
                    res: res
                  });
                }
              });
            } else {
              return Promise.reject({
                code: 4,
                msg: "\u8DF3\u8FC7\u652F\u4ED8",
                res: res
              });
            }
          } else if (_this._type === 'miniprogram') {
            return Promise.resolve({
              code: 0,
              msg: "\u652F\u4ED8\u5B8C\u6210",
              res: res
            });
          } else {
            var msg = "\u8BF7\u901A\u8FC7 config({type: ''}) \u65B9\u6CD5\u6307\u5B9A\u652F\u4ED8\u7C7B\u578B\uFF0C\u76EE\u524D\u7C7B\u578B\u4E3A ".concat(_this._type); // console.error(msg);

            return Promise.reject({
              code: 3,
              msg: msg,
              res: res
            });
          }
        } else {
          return Promise.reject({
            code: 2,
            msg: "\u8FD4\u56DE\u72B6\u6001\u7801\u9519\u8BEF",
            res: res
          });
        }
      });
    } else if (this._channel === 'alipay' || this._channel === 'antcreditpay') {
      var that = this;
      return _httpRequest["default"].post(url, params, opts).then(function (res) {
        if (res.code === 10000) {
          var aliH5BrowserPay = res.data.aliH5BrowserPay;
          var divId = document.getElementById('alipayDiv');

          if (!divId) {
            var div = document.createElement('div');
            div.setAttribute('id', 'alipayDiv');
            div.innerHTML = aliH5BrowserPay.from;
            document.body.appendChild(div);
          } else {
            divId.innerHTML = aliH5BrowserPay.from;
          }

          document.forms[0].submit();
          return Promise.resolve({
            code: 0,
            msg: '支付完成',
            res: res,
            channel: that._channel
          });
        } else {
          return Promise.reject({
            code: 2,
            msg: "\u8FD4\u56DE\u72B6\u6001\u7801\u9519\u8BEF",
            res: res
          });
        }
      });
    } else if (this._channel === 'banlancepay') {
      var _that = this;

      return _httpRequest["default"].post(url, params, opts).then(function (res) {
        if (res.code === 10000) {
          return Promise.resolve({
            code: 0,
            msg: '支付完成',
            res: res,
            channel: _that._channel
          });
        } else {
          return Promise.reject({
            code: 2,
            msg: "\u8FD4\u56DE\u72B6\u6001\u7801\u9519\u8BEF",
            res: res,
            channel: _that._channel
          });
        }
      });
    }
  },
  _wxJSAPIPay: function _wxJSAPIPay(options, response) {
    console.log('enter-_wxJSAPIPay======');
    return new Promise(function (resolve, reject) {
      function onBridgeReady() {
        WeixinJSBridge.invoke('getBrandWCPayRequest', options, function (res) {
          console.log('getBrandWCPayRequest-res======', res);

          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            resolve({
              code: 0,
              msg: '支付完成',
              wxRes: res,
              res: response
            });
          } else {
            reject({
              code: 1,
              msg: "\u5FAE\u4FE1\u652F\u4ED8\u5931\u8D25",
              wxRes: res,
              res: response
            });
          }
        });
      }

      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    });
  },

  /**
   * 校验订单
   * @param {Object} options
   * @options {string} options.params 校验订单的参数
   * @return {Promise<any>}
   *
   */
  checkStatus: function checkStatus() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$url2 = options.url,
        url = _options$url2 === void 0 ? '/mall-server/api/order/queryPayStatus' : _options$url2,
        params = options.params,
        _options$requestOptio2 = options.requestOptions,
        requestOptions = _options$requestOptio2 === void 0 ? {} : _options$requestOptio2;
    return _httpRequest["default"].get(url, params, (0, _common.defaults)(requestOptions, {
      forceAjax: true
    }));
  },

  /**
   * 在调用结果页调用
   * @returns {Promise<any>}
   * paySDK.onFinishPay().then(() => {
   *   // 支付完成后的逻辑
   *
   * })
   */
  onFinishPay: function onFinishPay() {
    var _this2 = this;

    return new Promise(function (reslove) {
      if (_this2._channel === 'wxpay') {
        if (_this2._type === 'h5') {
          var url = new URLSearchParams(location.search);
          var orderId = url.get(PRE_ORDER_ID);
          var orderStatus = +url.get(ORDER_STATUS);

          if (orderStatus === 0) {
            if (orderId) {
              reslove({
                code: 0,
                msg: '支付完成',
                res: {
                  orderId: orderId,
                  status: orderStatus
                }
              });
            }
          }
        }
      }
    });
  }
};
exports.paySDK = paySDK;